import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../../app.config.service';
import { IAuthDataResponse } from '@shared/interfaces/IAuthData';

@Injectable()
export class AuthService {
  static appConfig: any;

  constructor(private http: HttpClient, private appConfigService: AppConfigService) {}

  authorize(): Promise<IAuthDataResponse> {
    const endpoint = encodeURI(`${this.appConfigService?.settings?.gatewayURL}/v1/authorize`);
    return this.http.get<IAuthDataResponse>(endpoint).toPromise();
  }
}
